import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {},
};

const getDetailCampaignSlice = createSlice({
  name: "getDetailCampaign",
  initialState,
  reducers: {
    getDetailCampaignStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailCampaignSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDetailCampaignFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDetailCampaign: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = {};
    },
  },
});

export const {
  getDetailCampaignStart,
  getDetailCampaignSuccess,
  getDetailCampaignFailed,
  resetDetailCampaign,
} = getDetailCampaignSlice.actions;

export default getDetailCampaignSlice.reducer;
